// NGRX
import {EntityState, EntityAdapter, createEntityAdapter} from '@ngrx/entity';
// Actions
import {PropertyTypeActions, PropertyTypeActionTypes} from '../_actions/property-type.actions';
// Models
import {PropertyType} from '../_models/property-type.model';
import {QueryParamsModel} from '../../_base/crud';

export interface PropertyTypesState extends EntityState<PropertyType> {
    isAllPropertyTypesLoaded: boolean;
    queryRowsCount: number;
    queryResult: PropertyType[];
    lastCreatedPropertyTypeId: number;
    listLoading: boolean;
    actionLoading: boolean;
    totalCount: number;
    totalTrashed: number;
    totalAdminTrashed: number;

    lastQuery: QueryParamsModel;
    showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<PropertyType> = createEntityAdapter<PropertyType>();

export const initialPropertyTypeState: PropertyTypesState = adapter.getInitialState({
    isAllPropertyTypesLoaded: false,
    queryRowsCount: 0,
    queryResult: [],
    lastCreatedPropertyTypeId: undefined,
    listLoading: false,
    actionLoading: false,
    totalCount: 0,
    totalTrashed: 0,
    totalAdminTrashed: 0,
    lastQuery: new QueryParamsModel({}),
    showInitWaitingMessage: true
});

export function propertyTypesReducer(state = initialPropertyTypeState, action: PropertyTypeActions): PropertyTypesState {
    switch (action.type) {
        case PropertyTypeActionTypes.PropertyTypesPageToggleLoading:
            return {
                ...state, listLoading: action.payload.isLoading, lastCreatedPropertyTypeId: undefined
            };
        case PropertyTypeActionTypes.PropertyTypeActionToggleLoading:
            return {
                ...state, actionLoading: action.payload.isLoading
            };
        case PropertyTypeActionTypes.PropertyTypeOnServerCreated:
            return {
                ...state
            };
        case PropertyTypeActionTypes.PropertyTypeCreated:
            return adapter.addOne(action.payload.item, {
                ...state, lastCreatedPropertyTypeId: action.payload.item.id
            });
        case PropertyTypeActionTypes.PropertyTypeUpdated:
            return adapter.updateOne(action.payload.partialItem, state);

        case PropertyTypeActionTypes.AllPropertyTypesLoaded:
            return adapter.addAll(action.payload.items, {
                ...state, isAllPropertyTypesLoaded: true
            });
        case PropertyTypeActionTypes.PropertyTypesPageCancelled:
            return {
                ...state, listLoading: false, queryRowsCount: 0, queryResult: [], lastQuery: new QueryParamsModel({})
            };
        case PropertyTypeActionTypes.PropertyTypesPageLoaded:
            return adapter.addMany(action.payload.items, {
                ...initialPropertyTypeState,
                totalCount: action.payload.totalCount,
                totalTrashed: action.payload.totalTrashed,
                totalAdminTrashed: action.payload.totalAdminTrashed,
                listLoading: false,
                lastQuery: action.payload.page,
                showInitWaitingMessage: false
            });

        case PropertyTypeActionTypes.PropertyTypeDeleted:
            return adapter.removeOne(action.payload.id, {
                ...state, totalTrashed: state.totalTrashed + 1
            });

        case PropertyTypeActionTypes.PropertyTypeRestored:
            return adapter.addOne(action.payload.item, {
                ...state, totalTrashed: state.totalTrashed - 1
            });

        case PropertyTypeActionTypes.PropertyTypeDeletedFromTrash:
            return {
                ...state, totalTrashed: state.totalTrashed - 1, totalAdminTrashed: state.totalAdminTrashed + 1
            };

        // Admin Trash Action
        case PropertyTypeActionTypes.PropertyTypeAdminRestored:
            return adapter.addOne(action.payload.item, {
                ...state, totalAdminTrashed: state.totalAdminTrashed - 1
            });

        case PropertyTypeActionTypes.PropertyTypeDeletedFromAdminTrash:
            return {
                ...state, totalAdminTrashed: state.totalAdminTrashed - 1
            };
        case PropertyTypeActionTypes.PropertyTypeTrashFlushed:
            return {
                ...state, totalTrashed: 0, totalAdminTrashed: state.totalAdminTrashed + state.totalTrashed
            };
        default:
            return state;
    }
}

export const {
    selectAll,
    selectEntities,
    selectIds,
    selectTotal
} = adapter.getSelectors();
